import {
  formatCurrency,
  formatDateTime,
} from '@airship-platform/airship-patterns';
import { EmptyState, FlexBox } from '@airship-platform/jam-web/components';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import { AppointmentHistoryDetail } from '../../../data-access/appointmentHistory';
import SelectProposalButton from './SelectProposalButton';

interface TemplateDetailsProps {
  template?: AppointmentHistoryDetail;
}

const ProposalTemplatesHistoryDetail: React.FC<TemplateDetailsProps> = ({
  template,
}) => {
  if (!template) {
    return <EmptyState title="No proposal template found" subtitle="" />;
  }

  return (
    <FlexBox flexDirection={'column'} gap={4} width={'100%'}>
      <FlexBox flexDirection={'column'} gap={1}>
        <Typography variant={'subtitle2'}>Customer details</Typography>
        <Typography variant={'h4'}>{template.customer.name}</Typography>
        <Typography variant={'subtitle1'}>
          {formatDateTime(template.appointment.startDateTime)}
        </Typography>
        <Typography variant={'body2'}>{template.location.address1}</Typography>
      </FlexBox>
      <Divider />
      <FlexBox flexDirection={'column'} gap={2}>
        <Typography variant={'subtitle2'}>Option details</Typography>
        {template.options.map((option) => (
          <FlexBox
            key={option.appointmentProposalOptionId}
            alignItems={'center'}
            justifyContent={'space-between'}
          >
            <FlexBox flexDirection={'column'} gap={1}>
              <Typography variant={'h4'}>{option.name}</Typography>
              {template.proposalProducts
                .filter(
                  (p) =>
                    p.appointmentProposalOptionId ===
                    option.appointmentProposalOptionId
                )
                .map((product) => (
                  <Typography
                    key={`${product.appointmentProposalOptionId}-${product.appointmentProposalOptionProductId}`}
                    variant={'body2'}
                  >{`${product.name} (x${product.quantity})`}</Typography>
                ))}
            </FlexBox>
            <Typography variant={'body2'}>
              {formatCurrency(
                template.proposalProducts
                  .filter(
                    (p) =>
                      p.appointmentProposalOptionId ===
                      option.appointmentProposalOptionId
                  )
                  .reduce(
                    (total, product) =>
                      total + product.price * product.quantity,
                    0
                  )
              )}
            </Typography>
          </FlexBox>
        ))}
      </FlexBox>
      <SelectProposalButton
        appointmentId={template.appointmentId}
        appointmentProposalId={template.proposal.appointmentProposalId}
      />
    </FlexBox>
  );
};

export default ProposalTemplatesHistoryDetail;
